// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"154":"5b5116f1","198":"e2de3604","458":"e2de3604","475":"e2de3604"}[chunkId] + ".chunk.css";
};